<script lang="ts" setup>
import EmailLoginForm from '@/components/auth/EmailLoginForm.vue';
</script>

<template>
  <UiCard class="w-full max-w-[600px] shadow-lg border-border/50">
    <UiCardHeader class="space-y-3 pb-6">
      <UiCardTitle class="text-3xl font-bold text-center"> Welcome </UiCardTitle>
      <UiCardDescription class="text-center text-base">
        Sign in to your account to continue
      </UiCardDescription>
    </UiCardHeader>
    <UiCardContent class="pt-2">
      <div class="flex flex-col items-center justify-center">
        <!-- Email Login Form -->
        <div class="w-full">
          <EmailLoginForm />
        </div>
      </div>
    </UiCardContent>
  </UiCard>
</template>

<style scoped></style>
